import PropTypes from 'prop-types';
import { styled, Typography } from '@mui/material';
import Colors from 'js/constants/colors';

const Container = styled('div')({
    padding: '10px 15px 10px 15px',
    borderTop: `1px solid ${Colors.GRAY_BORDER}`
});
const BubbleContentSummary = (props) => {
    if (!props.size || props.size <= 1) {
        return null
    }

    return (<Container data-testid="bubble-content-summary">
        <Typography
            sx={{
                fontWeight: 400,
                fontSize: '12px',
                lineHeight: '20px',
                letterSpacing: '0.15px',
                color: Colors.BLACK_87_OPAQUE,
            }}
        >
            {`${props?.size ? props?.size : 0} properties found at this location`}
        </Typography>
    </Container>);
};
BubbleContentSummary.propTypes = {
    size: PropTypes.number
}
export default BubbleContentSummary;
